import { connect } from 'react-redux'
import RegistrationPlugin from '../../components/registration-plugin'

const mapStateToProps = state => ({...state.registrationPlugin})

const mapDispatchToProps = dispatch => ({
})

export default connect(mapStateToProps, mapDispatchToProps)(RegistrationPlugin)
